export const PERSISTENCE_TYPE = {
    LOCAL_STORAGE: 'LOCAL_STORAGE',
    DB_STORAGE: 'DB_STORAGE',
    REPORT_STORAGE: 'REPORT_STORAGE',
    MEMORY: 'MEMORY',
};
